import { useAppDispatch } from "../../../hooks/hooks";
import { useCallback } from "react";
import { callAsync } from "../../../util/sliceUtil";
import { downloadTestResultWideAsync } from "../../../store/dataSearchSlice";
import { useDownloadFile } from "../../../hooks/common/useDownloadFile";
import { useUtil } from "../../../util/hooks/useUtil";
import { TestResultSearchCondition } from "../../../types/dataSearch";

interface ReturnType {
  downloadTestResultWide: (_: TestResultSearchCondition) => void;
}

export function useTestResultWideDownloader(): ReturnType {
  const dispatch = useAppDispatch();
  const { getDownloadExcelFile } = useDownloadFile();
  const { defaultErrorMessage } = useUtil();

  const downloadTestResultWide = useCallback(
    (condition: TestResultSearchCondition) => {
      callAsync(
        dispatch(downloadTestResultWideAsync(condition)).unwrap(),
        (result) => getDownloadExcelFile(result, "test-result-item-wide"),
        () => {
          alert(defaultErrorMessage);
        }
      ).then();
    },
    [defaultErrorMessage, dispatch, getDownloadExcelFile]
  );

  return {
    downloadTestResultWide,
  };
}
